import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Row, Select, Space } from 'antd';
import {
  getCommunities,
  getCommunityEvents
} from '../../services/communityService';
import Title from 'antd/es/typography/Title';
import CommunityEventTable from './components/CommunityEventTable';
import AddCommunityEvent from './components/AddCommunityEvent';
import { useForm } from 'antd/lib/form/Form';

const { Option } = Select;

const CommunityEventListPage = () => {
  const [form] = useForm();

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalData, setTotalData] = useState(0);
  const [events, setEvents] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [visibleAddModal, setVisibleAddModal] = useState(false);
  const [filters, setFilters] = useState({ communityCode: null });

  const onClickModal = () => {
    setVisibleAddModal(true);
  };

  const onCancelModal = () => {
    setVisibleAddModal(false);
  };

  const getCommunityList = useCallback(async () => {
    await getCommunities({ pageSize: 10000, pageNo: 1 })
      .then((response) => {
        const communities = response?.data?.paginatedList.sort(
          (communityA, communityB) =>
            communityA?.title?.localeCompare(communityB?.title)
        );
        setCommunities(communities);
      })
      .catch((error) => {
        console.log(
          'Error getting communities list from the admin backend:',
          error
        );
        alert('Getting communities list from the backend failed!');
      });
  }, []);

  const getCommunityEventList = useCallback(async () => {
    await getCommunityEvents({ pageSize, pageNo, ...filters })
      .then((response) => {
        const data = response.data;
        const eventsList = data.paginatedList;
        setEvents(eventsList);
        setTotalData(data.totalCount);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  }, [filters, pageNo, pageSize]);

  const resetForm = () => {
    form.resetFields();
    form.submit();
  };

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
  };

  useEffect(() => {
    getCommunityList();
  }, [getCommunityList]);

  useEffect(() => {
    getCommunityEventList();
  }, [getCommunityEventList]);

  return (
    <div>
      <div>
        <Space size="large">
          <Title level={3} style={{ width: 300 }}>
            Community Events
          </Title>
          <Button type="ghost" onClick={onClickModal}>
            Add
          </Button>
        </Space>

        <Form form={form} onFinish={(values) => setFilters(values)}>
          <Row justify="space-between" align="center">
            <Col>
              <Title level={5}>Filters</Title>
            </Col>
            <Col>
              <Row gutter={16}>
                <Col>
                  <Form.Item name="communityCode">
                    <Select placeholder="Select Community Code">
                      {communities?.map((option, index) => (
                        <Option key={index} value={option?.code}>
                          {option?.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Col>
                <Col>
                  <Button htmlType="button" onClick={resetForm}>
                    Clear
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>

        <Title level={5}>Total {totalData} Record(s)</Title>
        <section>
          <CommunityEventTable
            data={events}
            communities={communities}
            totalData={totalData}
            onPaginationChange={onPaginationChange}
          />
        </section>

        <AddCommunityEvent
          isOpen={visibleAddModal}
          onCancelModal={onCancelModal}
          communityList={communities}
        />
      </div>
    </div>
  );
};

export default CommunityEventListPage;
